import dashboardRoutes from './route';

export default dashboardRoutes;